import {SessionLocaleService} from '../../../../projects/shared-lib/src/lib/services/session-locale.service';
import {HttpTemplateService} from './http-template.service';
import {RequestCache, RequestCacheWithMap} from '../../../../projects/shared-lib/src/lib/services/request-cache-with-map.service';
import {HelpsService} from './helps.service';
import {CalendarObserverService} from './calendar-observer.service';
import {LangsObserverService} from '../../../../projects/shared-lib/src/lib/services/langs-observer.service';
import {ActionCartService} from './action-cart.service';

import {AuthenticationUserService} from '../../../../projects/shared-lib/src/lib/services/authentication-user.service';

import {BrowserFaviconsService} from './browser-favicons.service';
import {ThemeService} from '../../../../projects/shared-lib/src/lib/services/theme.service';

export const SERVICES_SHARED: any [] = [
    SessionLocaleService,
    HttpTemplateService,
    CalendarObserverService,
    { provide: RequestCache, useClass: RequestCacheWithMap },
    HelpsService,
    LangsObserverService,
    ActionCartService,


    AuthenticationUserService,

    BrowserFaviconsService,
    ThemeService
];


